// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cancellation-reasons {\n  padding: 24px;\n}\n.cancellation-reasons .ant-radio-group {\n  width: 100%;\n  margin-bottom: 10px;\n}\n.cancellation-reasons .ant-alert {\n  margin-bottom: 10px;\n}\n.cancellation-reasons .textarea-label {\n  padding-bottom: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
